module.exports = __webpack_public_path__ + "static/img/block03.aa1b3c7e.png";